import { literals } from "@/constants/literals";
import { formatDateDDMmmYYYY } from "@/lib/dates";
import { formatBooleanText, formatOptionalText } from "@/lib/texts.utils";
import type { ImageDeletionRequestApi } from "@/types/types.d";

const RequestCardMobile = ({
  item,
  onClick,
}: {
  item: ImageDeletionRequestApi;
  onClick: (item: ImageDeletionRequestApi) => void;
}) => {
  const handleOnClick = () => {
    onClick(item);
  };

  const fileName = item.s3Key.split("/").pop() ?? item.s3Key;

  return (
    <button
      data-testid="request-card-mobile"
      onClick={handleOnClick}
      type="button"
      className="flex flex-col gap-2 border rounded-sm p-4 text-left"
    >
      <div className="flex gap-2 justify-between">
        <BlockInfo
          label={literals.requestDate}
          value={formatDateDDMmmYYYY(item.createdAt)}
        />
        <BlockInfo
          label={literals.step}
          value={formatOptionalText(item.step)}
        />
      </div>

      <div className="w-full border-t" />

      <div className="flex flex-col gap-2">
        <BlockInfoHorizontal
          label={literals.workstation}
          value={formatOptionalText(item.area)}
        />
        <BlockInfoHorizontal label={literals.name} value={fileName} />
        <BlockInfoHorizontal
          label={literals.visibleClient}
          value={formatBooleanText(item.imageGroupVisible)}
        />
        <BlockInfoVertical
          label={literals.description}
          value={formatOptionalText(item.imageGroupDescription)}
        />
      </div>
    </button>
  );
};

export default RequestCardMobile;

const BlockInfo = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className="block">
      <p className="text-sm">{label}</p>
      <p className="font-ib-bold text-md">{value}</p>
    </div>
  );
};

const BlockInfoHorizontal = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => {
  return (
    <div className="flex gap-1 justify-between items-center">
      <p className="text-[#666666]">{label}:</p>
      <p className="text-black text-right">{value}</p>
    </div>
  );
};

const BlockInfoVertical = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => {
  return (
    <div className="block gap-1">
      <p className="text-[#666666]">{label}:</p>
      <p className="text-black">{value}</p>
    </div>
  );
};
